import { AxiosError } from 'axios';
import { POST_ACCOUNT_ACTIVATION_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request Model
// =============================================================================
export interface AccountActivationRequest {
  username: string;
  dateOfBirth: string;
}

export interface AccountActivationResponse {
  countryCode?: string;
  email: string;
  number?: string;
  username: string;
  resetLink: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: AccountActivationResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostAccountActivation = ({ onSuccess, onError }: Input = {}) => {
  const postAccountActivation = async (reqBody: AccountActivationRequest) => {
    const res = await axiosClient.post<AccountActivationResponse>(
      POST_ACCOUNT_ACTIVATION_URL,
      reqBody
    );

    return res.data;
  };

  return useCustomMutation(
    postAccountActivation,
    {
      onSuccess,
      onError,
    },
    false
  );
};
